import { GrMail } from "react-icons/gr";
import { FaFacebookMessenger, FaLinkedin } from "react-icons/fa";

export const ContactDatas = [
  {
    icon: <GrMail />,
    title: "Email",
    info: "kin0905152701@gmail.com",
    link: "mailto:kin0905152701@gmail.com",
  },
  {
    icon: <FaFacebookMessenger />,
    title: "Messenger",
    info: "Kin Nguyễn",
    link: "https://www.facebook.com/messages/t/100003134161056",
  },
  {
    icon: <FaLinkedin />,
    title: "LinkedIn",
    info: "Minh Quân",
    link: "https://www.linkedin.com/in/qu%C3%A2n-minh-2a862b24a/",
  },
];